import { IKnmDelegateType } from 'APIPackage/CatalogsModule/interfaces/IKnmDelegateType';

import { IKnmDelegateTypeSelectOption } from '../interfaces/IKnmDelegateTypeSelectOption';

export const createKnmDelegateTypeSelectOption = (knmDelegateType: IKnmDelegateType): IKnmDelegateTypeSelectOption => ({
  ...knmDelegateType,
  label: knmDelegateType.name,
  value: knmDelegateType.code,
});
